<img [ngClass]="{'no-active': !hasReceipt}" src="assets/images/receipt4.jpg"
    style="width: 20px" alt="" />